<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="mContent__header bg-primary py-3 px-5">
  <h1 class="text-white mb-1">Tutor Details</h1>
  <div class="mControls">
    <div class="input-group mr-auto align-items-center">
      <span class="h2 text-white text-white"> {{ tutor?.first_name +" "+(tutor?.second_name ? tutor?.second_name :
        '')+" " +(tutor?.last_name ? tutor?.last_name : '') }}</span>
    </div>
    <div class="mControls__right">
      <div *ngIf="this.loggedInUser!=3">
        <div class="input-group"><button mat-raised-button color="warn" (click)="activateDeactivateTutor()">
            <mat-icon>block</mat-icon>{{tutor?.is_active ? 'Deactivate' : 'Activate'}} Tutor
          </button></div>
        </div>
        <div *ngIf="this.loggedInUser!=3">
        <div class="input-group"><button mat-raised-button (click)="editTutor(tutor.id)">
            <mat-icon>edit</mat-icon>Edit Tutor
          </button></div>
        </div>
      <div class="input-group"><button mat-raised-button (click)="tutorListDetails()">
          <mat-icon>done</mat-icon> Done
        </button></div>
    </div>
  </div>
</div>
<div class="overflow-auto">
  <div class="row mx-0 mt-4">
    <div class="col-lg-6 px-2 mb-3">
      <div class="card h-100">
        <div class="card-header">Tutor Info</div>
        <div class="card-body">
          <ul class="list-unstyled form-lr">
            <li>
              <span class="form-lr__left">Name</span>
              <span class="form-lr__right">{{ tutor?.first_name +" "+(tutor?.second_name ? tutor?.second_name : '')+" "
                +(tutor?.last_name ? tutor?.last_name : '') }}</span>
            </li>
            <li>
              <span class="form-lr__left">Email</span>
              <span class="form-lr__right">{{tutor?.email ? tutor?.email : 'N/A'}}</span>
            </li>
            <li>
              <span class="form-lr__left">Phone</span>
              <span class="form-lr__right">{{tutor?.phone ? tutor?.phone : 'N/A'}}</span>
            </li>
            <li>
              <span class="form-lr__left">Alternate Phone</span>
              <span class="form-lr__right">{{tutor?.second_phone ? tutor?.second_phone : 'N/A'}}</span>
            </li>
            <li>
              <span class="form-lr__left">Preference</span>
              <span class="form-lr__right">
                {{tutor?.preference ? '' : 'N/A'}}
                <div>
                  <span class="color-block" [ngStyle]="{
                    'background-color':tutor?.preference?.preference_color_code}"></span>
                </div>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-6 px-2 mb-3">
      <div class="card h-100">
        <div class="card-header">Program Details</div>
        <div class="card-body">
          <ul class="list-unstyled form-lr">
            <li>
              <span class="form-lr__left">Status</span>
              <span class="form-lr__right">{{tutor?.is_active ? 'Active' : 'Inactive'}}</span>
            </li>
            <li>
              <span class="form-lr__left">Commitment Level</span>
              <span class="form-lr__right">{{tutor?.commitment_level.commitment_level ?
                tutor?.commitment_level.commitment_level : 'N/A'}}</span>
            </li>
            <li>
              <span class="form-lr__left">Schools</span>
              <span *ngIf="!tutor?.schools?.length" class="form-lr__right">N/A</span>
              <div class="form-lr__right">
                <ul class="list-unstyled list-name">
                  <li *ngFor="let school of schoolNames">
                    <span class="text">{{school ? school: 'N/A' }}</span>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <span class="form-lr__left">Specialist</span>
              <span class="form-lr__right">{{tutor?.is_specialist ? "Yes" : "No"}}</span>
            </li>
            <li *ngIf="loggedInUser!==tutorRoleId">
              <span class="form-lr__left">Teaching Experience</span>
              <span class="form-lr__right">{{tutor?.is_teacher_experience ? "Yes" : "No"}}</span>
            </li>
            <li>
              <span class="form-lr__left">Tutoring Experience</span>
              <span class="form-lr__right">{{tutor?.is_counselor_experience ? "Yes" : "No"}}</span>
            </li>
            <li *ngIf="loggedInUser!==tutorRoleId">
              <span class="form-lr__left">Background Check</span>
              <span class="form-lr__right">{{tutor?.is_background_checked ? "Completed" : "Incomplete"}}</span>
            </li>
            <li *ngIf="loggedInUser!==tutorRoleId">
              <span class="form-lr__left">Code of Ethics</span>
              <span class="form-lr__right">{{tutor?.is_code_of_ethics ? "Completed" : "Incomplete"}}</span>
            </li>
            <li  *ngIf="loggedInUser!==tutorRoleId">
              <span class="form-lr__left">Shadow Days</span>
              <span class="form-lr__right">{{tutor?.is_deleted ? "Completed" : "Incomplete"}}</span>
            </li>
            <li *ngIf="loggedInUser!==tutorRoleId">
              <span class="form-lr__left">Is this Tutor Certified?</span>
              <span class="form-lr__right">
                <mat-radio-group
                  class="hug-form-radio-group"
                  [value]="tutor?.is_certified ? 1 : 0"
                  disabled
                >
                  <mat-radio-button [value]="0">No</mat-radio-button>
                  <mat-radio-button [value]="1">Yes</mat-radio-button>
                </mat-radio-group>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-6 px-2 mb-3">
      <div class="card h-100">
        <div class="card-header">Emergency Contact Info</div>
        <div class="card-body">
          <ul class="list-unstyled form-lr">
            <li>
              <span class="form-lr__left">Name</span>
              <span class="form-lr__right">{{ (tutor?.emergency_contact_first_name?
                tutor?.emergency_contact_first_name:'' )+" "+(tutor?.emergency_contact_last_name ?
                tutor?.emergency_contact_last_name: 'N/A') }}</span>
            </li>
            <li>
              <span class="form-lr__left">Phone</span>
              <span class="form-lr__right">{{tutor?.emergency_contact_number ? tutor?.emergency_contact_number :
                'N/A'}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div  *ngIf="loggedInUser!==tutorRoleId" class="col-lg-6 px-2 mb-3">
      <div class="card h-100">
        <div class="card-header">Notes</div>
        <div class="card-body">
          <ul class="list-unstyled form-lr">
            <li>
              <span class="form-lr__right">{{tutor?.note ? tutor?.note: 'N/A'}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
